export default "__VITE_ASSET__Kot94td$__"